import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["invited.phone_number"],
  phoneNumber => phoneNumber
);
